/**
 * Memoized connection link item for links list.
 * Prevents re-renders when other links change.
 */
import { memo } from "react";

export interface ConnectionLinkItemProps {
  link: {
    id: string;
    source_id: string;
    target_id: string;
    link_type: string;
  };
  isSelected: boolean;
  sourceName: string;
  targetName: string;
  onSelect: (id: string) => void;
  onRemove: (id: string) => void;
}

export const ConnectionLinkItem = memo<ConnectionLinkItemProps>(
  ({ link, isSelected, sourceName, targetName, onSelect, onRemove }) => (
    <div
      role="button"
      tabIndex={0}
      onClick={() => onSelect(link.id)}
      onKeyDown={(e) => {
        if (e.key === "Enter" || e.key === " ") {
          e.preventDefault();
          onSelect(link.id);
        }
      }}
      className={`flex items-center justify-between p-3 rounded-lg border transition-colors cursor-pointer ${
        isSelected ? "bg-sa-success/10 border-sa-success" : "bg-sa-success/10 border-sa-success/40"
      }`}
    >
      <div className="flex items-center gap-2">
        <span
          className={`px-2 py-0.5 text-xs font-medium rounded ${
            link.link_type === "signal"
              ? "bg-primary/10 text-primary"
              : "bg-sa-warning/10 text-sa-warning"
          }`}
        >
          {link.link_type}
        </span>
        <span className="text-sm text-sa-text">
          {sourceName} → {targetName}
        </span>
      </div>
      <button
        onClick={(event) => {
          event.stopPropagation();
          onRemove(link.id);
        }}
        className="text-sa-danger hover:text-sa-danger text-sm font-medium"
        data-testid={`wire-remove-${link.id}`}
      >
        Remove
      </button>
    </div>
  ),
);

ConnectionLinkItem.displayName = "ConnectionLinkItem";
